import React, { useState } from 'react';
import PurchaseOrderList from '../components/purchase-order/PurchaseOrderList';
import PurchaseOrderFormSleek from '../components/purchase-order/PurchaseOrderFormSleek';

const PurchaseOrder = () => {
    const [view, setView] = useState('list'); // 'list' or 'form'
    const [selectedOrder, setSelectedOrder] = useState(null);

    const handleCreateNew = () => {
        setSelectedOrder(null);
        setView('form');
    };

    const handleEditOrder = (order) => {
        setSelectedOrder(order);
        setView('form');
    };

    const handleBackToList = () => {
        setSelectedOrder(null);
        setView('list');
    };

    return (
        <div className="h-full ">
            {view === 'list' ? (
                <PurchaseOrderList
                    onCreateNew={handleCreateNew}
                    onEditOrder={handleEditOrder}
                />
            ) : (
                <PurchaseOrderFormSleek
                    onBack={handleBackToList}
                    orderDataId={selectedOrder}
                />
            )}
        </div>
    );
};

export default PurchaseOrder;
